import Vue from "vue";
import VueSocketIO from "vue-socket.io";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/ru-RU";
import "element-ui/lib/theme-chalk/index.css";
import VueClipboard from "vue-clipboard2";
//
import App from "@/components/App";
//
import router from "@/router";
import store from "@/store";
//
import mixins from "./mixins";
//
// import Dayjs from "vue-dayjs";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/ru";
//
dayjs.locale("ru");
dayjs.extend(relativeTime);
//
Vue.config.productionTip = false;
//
Vue.use(VueClipboard);
Vue.use(ElementUI, { locale });
Vue.use(
  new VueSocketIO({
    debug: false,
    connection:
      process.env.NODE_ENV === "production" ? "https://api.uchet.twowaysout.monster" : "http://localhost:3000"
  })
);
// Vue.use(Dayjs, {
//   // language set, default cn
//   lang: "en"
// });
Object.defineProperties(Vue.prototype, {
  $dayjs: {
    get() {
      return dayjs;
    }
  }
});
//
Vue.mixin(mixins);
new Vue({
  el: "#app",
  router,
  store,
  // components: { App },
  // template: '<App/>'
  render: createElement => createElement(App)
});



// WEBPACK FOOTER //
// ./src/main.js